import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class TeamResultModel extends Model 
{
	@attr name;
	@attr club;
	@attr country;
	@attr bib;
	@attr('number',{defaultValue: 0}) id1;
	@attr('number',{defaultValue: 0}) id2;
	@attr('number',{defaultValue: 0}) id3;
	@attr({defaultValue:'OK'}) status;
	@attr('date') assignedStartTime;
	@attr('date') startTime;
	@attr('date') finishTime;
	@attr classGroupName;
	@attr splits;
	@attr teamMembers;
	@attr finishSplit;
	@attr totalTimeInMilliseconds;
	@attr('number',{defaultValue:0}) place;
	@attr('boolean') isTie;
	
	@belongsTo('event', {inverse: 'teamResults', async: true}) EventId;
	@belongsTo('class-group', {inverse: 'teamResults', async: true}) ClassGroupId;
	
	get placeOrStatus()
	{
		const status = this.status;
		const place = this.place;
		
		if(status == 'OK')
			return place;
		return status;
	}
}

/*
{
	"id":5,
	"EventId":3,
	"name":"test team",
	"assignedStartTime":"2017-02-21T15:03:04.000Z",
	"startTime":"2017-03-19T22:44:38.726Z",
	"finishTime":"2017-03-16T20:03:48.457Z",
	"classGroupId":26,
	"classGroupName":"U16 Girls",
	"splits":
	[
		{
			"IntermediateTimingPointId":3,
			"IntermediateTimingPointName":"Lap",
			"IntermediateTimingPointDescription":"Lap Lane",
			"IntermediateTimingRecordId":473,
			"time":"2017-03-20T18:07:04.030Z"
		},
		{
			"IntermediateTimingPointId":3,
			"IntermediateTimingPointName":"Lap",
			"IntermediateTimingPointDescription":"Lap Lane"
		},
		{
			"IntermediateTimingPointId":3,
			"IntermediateTimingPointName":"Lap",
			"IntermediateTimingPointDescription":"Lap Lane"
		}
	]
}
*/